import { fetchdata } from 'apis/FetchData';
import { apiConfig } from 'config';

export const getDefaultSWVersion = () => {
  const url = apiConfig.swManagerGetDefaultSWVersion;
  return fetchdata(url, { method: 'GET' })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      throw e;
    });
};
